import { connect } from "react-redux";
import { HandymanAppState } from "../../../configuration/redux/reducers";
import CategoriesList from "../CategoriesList";
import { selectUserCategories } from "../actions";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface StateFromProps {
  isLoading: boolean;
  isCategoriesSelectedAndSaved: boolean;
}

interface DispatchFromProps {
  selectUserCategories: (categoryKeys: string[]) => void;
}

interface PassedProps {}

type Props = StateFromProps & DispatchFromProps & PassedProps;

const SelectUserCategories: React.FC<Props> = ({
  isLoading,
  isCategoriesSelectedAndSaved,
  selectUserCategories,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isCategoriesSelectedAndSaved) {
      navigate("/profile");
    }
  }, [isCategoriesSelectedAndSaved, navigate]);

  const onSubmit = (categoryKeys: string[]) => {
    selectUserCategories(categoryKeys);
  };

  return <CategoriesList onSubmit={onSubmit} isLoading={isLoading} />;
};

const mapStateToProps = (state: HandymanAppState): StateFromProps => ({
  isLoading: state.category.isLoading,
  isCategoriesSelectedAndSaved: state.category.isCategoriesSelectedAndSaved,
});

export default connect<StateFromProps, DispatchFromProps, any, HandymanAppState>(
  mapStateToProps,
  {
    selectUserCategories,
  }
)(SelectUserCategories);
